import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { GetNotificationPreferencesResponse, NotificationPreferenceCategoryResponseDto } from '@core-http';
import { NotificationsPreferencesService } from '@notifications/infra';
import { NotificationPreferenceCategoryQueryResult } from './notification-preferences.query-result';

export class NotificationPreferencesQueryHandler {
  private readonly service: NotificationsPreferencesService = inject(NotificationsPreferencesService);

  getPreferences(): Observable<NotificationPreferenceCategoryQueryResult[]> {
    return this.service.getPreferences().pipe(
      map((response: GetNotificationPreferencesResponse) =>
        response.categories.map((c: NotificationPreferenceCategoryResponseDto) => ({
          category: c.category,
          label: c.label,
          description: c.description,
          enabled: c.enabled,
          editable: c.editable
        }))
      )
    );
  }
}
